import { useTranslation as useReactI18nextTranslation } from 'react-i18next';

import type { Translate } from '../internationalization/translation';
import { applyOverwrites } from '../internationalization/translation-overwrites';
import { useApplicationContext } from './use-application-context';

export const useTranslate = (): Translate => {
    const { translate } = useApplicationContext();

    return translate;
};

export const useTranslateFromNearestProvider = (): Translate => {
    const { t } = useReactI18nextTranslation();

    return applyOverwrites(t);
};
